import { t } from "@/translations"

export type CategoryTranslations = {
    sortBy: string
    priceLowToHigh: string
    priceHighToLow: string
    newestFirst: string
    recommended: string
    showProducts: string
    filter: string
    loadMore: string
    showMore: string
    showPrev: string
    selected: string
    multipleSelected: string
    clearAll: string
    currentPage: string
    showFilterSorting: string
    hideFilterSorting: string
    products: string
    view: string
    viewingProducts: string
    loadPreviousPage: string
    noResults: string
}

type SanityTranslations = Partial<CategoryTranslations>

const resolve = (sanity: string | undefined, fallback: string) =>
    sanity && sanity.trim() !== "" ? sanity : fallback

export function buildCategoryTranslations(
    langCode: string,
    sanity?: SanityTranslations | null
): CategoryTranslations {
    return {
        sortBy: resolve(sanity?.sortBy, t(langCode, "category_page.sort_by")),
        priceLowToHigh: resolve(
            sanity?.priceLowToHigh,
            t(langCode, "category_page.price_low_to_high")
        ),
        priceHighToLow: resolve(
            sanity?.priceHighToLow,
            t(langCode, "category_page.price_high_to_low")
        ),
        newestFirst: resolve(
            sanity?.newestFirst,
            t(langCode, "category_page.newest_first")
        ),
        recommended: resolve(
            sanity?.recommended,
            t(langCode, "category_page.recommended")
        ),
        showProducts: resolve(
            sanity?.showProducts,
            t(langCode, "category_page.show_products")
        ),
        filter: resolve(sanity?.filter, t(langCode, "category_page.filter")),
        loadMore: resolve(sanity?.loadMore, t(langCode, "category_page.load_more")),
        showMore: resolve(sanity?.showMore, t(langCode, "category_page.show_more")),
        showPrev: resolve(sanity?.showPrev, t(langCode, "category_page.show_prev")),
        selected: resolve(sanity?.selected, t(langCode, "category_page.selected")),
        multipleSelected: resolve(
            sanity?.multipleSelected,
            t(langCode, "category_page.multiple_selected")
        ),
        clearAll: resolve(sanity?.clearAll, t(langCode, "category_page.clear_all")),
        currentPage: resolve(
            sanity?.currentPage,
            t(langCode, "category_page.current_page")
        ),
        showFilterSorting: resolve(
            sanity?.showFilterSorting,
            t(langCode, "category_page.show_filter_sorting")
        ),
        hideFilterSorting: resolve(
            sanity?.hideFilterSorting,
            t(langCode, "category_page.hide_filter_sorting")
        ),
        products: resolve(sanity?.products, t(langCode, "category_page.products")),
        view: resolve(sanity?.view, t(langCode, "category_page.view")),
        viewingProducts: resolve(
            sanity?.viewingProducts,
            t(langCode, "category_page.viewing_products")
        ),
        loadPreviousPage: resolve(
            sanity?.loadPreviousPage,
            t(langCode, "category_page.load_previous_page")
        ),
        noResults: resolve(sanity?.noResults, t(langCode, "category_page.no_results"))
    }
}

export function formatViewingProducts(
    template: string,
    start: number,
    end: number,
    total: number
) {
    return template
        .replace("{start}", String(start))
        .replace("{end}", String(end))
        .replace("{total}", String(total))
}
